export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left'
  },
  {
    title: that.$l('table_label_name_cn') || '中文名称',
    field: 'scmCategoryName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title'
  },
  {
    title: that.$l('table_label_name_en') || '英文名称',
    field: 'scmCategoryEnName',
    minWidth: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: 'title'
  },
  {
    title: that.$l('table_label_status') || '状态',
    field: 'scmCategoryStatus',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: { default: 'status' }
  },
  {
    title: that.$l('form_label_created_by') || '创建人',
    field: 'createByName',
    width: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    title: that.$l('form_label_created_date') || '创建时间',
    field: 'createDate',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('form_label_modified_by') || '修改人',
    field: 'modifyByName',
    width: 120,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis'
  },
  {
    title: that.$l('form_label_modified_date') || '修改时间',
    field: 'modifyDate',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    headerAlign: 'center',
    fixed: 'right',
    align: 'center',
    width: 130,
    slots: {
      default: 'opt'
    }
  }
]
